import { ReactElement } from "react";

import styles from "./index.module.css";

export default function OneColSection(props: {
  children: ReactElement[];
}): ReactElement {
  return (
    <div className={styles.wrapper}>
      {props.children.map((child, i) => (
        <div key={i}>{child}</div>
      ))}
    </div>
  );
}
